var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _registerCSSInterfaceWithDefaultTheme = require('./utils/registerCSSInterfaceWithDefaultTheme');

var _registerCSSInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerCSSInterfaceWithDefaultTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _registerCSSInterfaceWithDefaultTheme2['default'])();


//////////////////
// WEBPACK FOOTER
// ./~/react-dates/lib/initialize.js
// module id = 2726
// module chunks = 0